import moment from 'moment';
import {
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_ENREGISTRE, SENS_VENTE,
} from '@/configuration/devisConf';
import { DATES_RENOUVELLEMENT } from '@/configuration/commande/commandeConf';

export default function genererCriteresRechercheLigneARenouveler() {
  return {
    auto: '',
    commercialId: null,
    etatsRenouvellement: [],
    dates: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    etatsDevisCommandeFacture: [
      ETAT_FACTURE_PARTIELLEMENT,
      ETAT_FACTURE,
      ETAT_ENREGISTRE,
    ],
    code: '',
    codesDossier: [],
    annonceur: null,
    payeur: null,
    optionDate: DATES_RENOUVELLEMENT,
    groupeIds: [],
    enseigneIds: [],
    typesProduits: [],
    sens: SENS_VENTE,
    libelle: '',
    fournisseursId: [],
    annonceurs: [],
    payeurs: [],
    interne: false,
    agencesId: [],
    produitRenouvelable: true,
  };
}
